
export const bismillahText="بِسۡمِ اللّٰہِ الرَّحۡمٰنِ الرَّحِیۡمِ ١"

export const ignoreSurah = new Map<number, boolean>([
    [1, true],
    [9, true],
]);